import React from 'react'
import {Helmet} from 'react-helmet'
import {useIntl} from 'react-intl'
import useCustomerServicePageConfig from '../hooks/use-page-config'

const CustomerServicePageMeta = () => {
    const {formatMessage} = useIntl()
    const {name, pageDescription, pageKeywords, pageTitle} = useCustomerServicePageConfig()

    const pageTitleString = formatMessage(
        {
            defaultMessage: '{pageTitle} | Stokke® Online Shop',
            id: 'global.page.title'
        },
        {pageTitle: pageTitle || name}
    )

    return (
        <Helmet>
            <title>{pageTitleString}</title>
            {pageDescription && <meta name="description" content={pageDescription} />}
            {pageKeywords && <meta name="keywords" content={pageKeywords} />}
        </Helmet>
    )
}

export default CustomerServicePageMeta
